import { combineReducers } from 'utils';
import { BaseAction, BaseInitialState, BaseState, baseFormReducer, baseReducer } from '../../Utils';
import {
  BaseZendeskFormAction,
  BaseZendeskFormState,
  Options,
  ZendeskWithProductsInitialState,
  addProductsReducer,
  baseZendeskFormReducer,
  validateProducts,
  validateQuestion,
  validateSubject
} from '../utils';

export const shippingAndDeliveryFormId = 29744537912338;
export const subjectFieldId = '29745598705810';

type InternalState = BaseState & BaseZendeskFormState;

export const shippingAndDeliveryInitialState: InternalState = {
  ...BaseInitialState,
  ...ZendeskWithProductsInitialState
};

type Action = BaseAction | BaseZendeskFormAction;

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseReducer,
  baseZendeskFormReducer,
  addProductsReducer
);

type ValidatedState = Omit<InternalState, 'subject' | 'products'> &
  Required<Pick<InternalState, 'subject' | 'products'>>;

export const isValid = (
  state: InternalState,
  dispatch: (action: Action) => void
): state is ValidatedState => {
  const isValidSubject = validateSubject(state, dispatch);
  const isValidQuestion = validateQuestion(state, dispatch);
  const isValidProducts = validateProducts(state, dispatch);

  return isValidSubject && isValidQuestion && isValidProducts;
};

export const getSubjectOptions = (): Options[] => {
  return [
    { id: 1, tag: 'sad_tracking_issue' },
    { id: 2, tag: 'sad_delivery' }
  ];
};
